import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import { ComponentStore } from '@ngrx/component-store'

import * as state from '../../../../../../state'

import { State } from './state'

/**
 * Manages the {@link State} of the navbar
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Store extends ComponentStore<State> {
  /** @see {@link State.extractFormattedDate} */
  private readonly _extractFormattedDateSg = this.selectSignal(
    _state => _state.extractFormattedDate,
  )

  constructor() {
    super(State.INITIAL)
  }

  /**
   * Gets the time of a {@link ents.core.summit.CheckIn.Response} in a readable
   * format
   *
   * @see {@link State.extractFormattedDate}
   */
  public extractFormattedDate(
    response: ents.core.summit.CheckIn.Response,
  ): string {
    return this._extractFormattedDateSg()(response)
  }

  /** @see {@link State.toggleDateFormat} */
  public toggleDateFormat(): void {
    this.patchState(State.toggleDateFormat)
  }
}
